/**
 * Combined Sworn Translator Q&A set (Wave 1 + Wave 2), de-duplicated by slug.
 * Every /sworn question surface (hub, /sworn/q/$slug, JSONL feed, sitemap)
 * reads from here so a new wave lands everywhere at once.
 */
import { SWORN_QA, type SwornQA } from "./questions-500";
import { SWORN_QA_WAVE2 } from "./questions-wave2";
import { SWORN_QA_WAVE3 } from "./questions-wave3";
import { SWORN_QA_WAVE4 } from "./questions-wave4";
import { liftToFloor } from "../_qa/topup-merge";
import { SWORN_TOPUP_AXIS } from "../_qa/topup-axes";

const merged: SwornQA[] = [];
const seen = new Set<string>();
for (const qa of [...SWORN_QA, ...SWORN_QA_WAVE2, ...SWORN_QA_WAVE3, ...SWORN_QA_WAVE4]) {
  if (seen.has(qa.slug)) continue;
  seen.add(qa.slug);
  merged.push(qa);
}

liftToFloor<SwornQA["cluster"], SwornQA>(merged, {
  prefix: "sworn-t7",
  asOf: "ข้อมูลทบทวน ณ สิงหาคม 2569 บัญชีรายชื่อนักแปลและรูปแบบที่แต่ละสถานทูตยอมรับเปลี่ยนได้ ควรยืนยันก่อนเริ่มงาน เว็บไซต์ไม่แสดงค่าบริการ ขอใบเสนอราคาเฉพาะเคสได้ทางโทรศัพท์ LINE หรืออีเมล",
  authorityTh: "สถานทูตหรือหน่วยงานทะเบียนของประเทศปลายทาง",
  clusterTh: "งานแปลโดยนักแปลสาบานตน",
  primary: SWORN_TOPUP_AXIS,
  clusters: { documents: "documents", process: "process", risk: "legal", location: "embassy" },
});

export const SWORN_QA_ALL: SwornQA[] = merged;

export const SWORN_QA_ALL_BY_SLUG: Record<string, SwornQA> = Object.fromEntries(
  SWORN_QA_ALL.map((q) => [q.slug, q]),
);

/** Total distinct phrasings covered (question + synonym clusters). */
export const SWORN_QA_PHRASING_COUNT = SWORN_QA_ALL.reduce(
  (n, qa) => n + 1 + qa.synonyms.length,
  0,
);
